<template>
    <a-form
        :form="drawerForm"
        layout="vertical"
    >
        <a-row 
            :gutter="20"
        >
            <a-col :span="12">
                <a-form-item
                    label="Keresztnév"
                >
                    <a-input
                        v-decorator="[
                            'firstName',
                            {
                                rules: [{
                                    required: true,
                                    message: 'Írjon be keresztnevet!'
                                }]
                            }
                        ]"
                        placeholder="Keresztnév"
                    >
                    </a-input>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item
                    label="Családnév"
                >
                    <a-input
                        v-decorator="[
                            'lastName',
                            {
                                rules: [{
                                    required: true,
                                    message: 'Írjon be keresztnevet!'
                                }]
                            }
                        ]"
                        placeholder="Családnév"
                    >
                    </a-input>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row>
            <a-col :span="24">
                <UserRightsComponent 
                />
            </a-col>
        </a-row>
    </a-form>
</template>

<script>
import UserRightsComponent from './UserRightsComponent.vue';

const formSchema = {
    firstName: '',
    lastName: ''
}

export default {
    components: {
        UserRightsComponent
    },

    props: {
        formValues: Object
    },

    data() {
        return {
            rightsData: [
                {
                    title: 'Admin',
                    description: 'admin jogok',
                    key: '1',
                    chosen: false
                },
                {
                    title: 'Olvasó',
                    description: 'olvasó jogok',
                    key: '2',
                    chosen: false
                },
                {
                    title: 'Szerkesztő',
                    description: 'szerkesztő jogok',
                    key: '3',
                    chosen: false
                }
            ]
        }
    },

    beforeCreate() {
        
        
    },

    created() {
        this.drawerForm = this.$form.createForm(this, {
            mapPropsToFields: () => {
                return {
                    firstName: this.$form.createFormField({
                        value: this.formValues.firstName
                    }),
                    lastName: this.$form.createFormField({
                        value: this.formValues.lastName
                    })
                }
            }
        });
    },

    watch: {
        formValues() {
            this.drawerForm.setFieldsValue({
                firstName: this.formValues.firstName,
                lastName: this.formValues.lastName
            })
        }
    },
}
</script>

<style>

</style>
